import { connect } from 'react-redux';

import {
  setShowConfirmModal,
  setPrescriptionStatus,
  setError,
  updateProductApplicationRate
} from 'experiment';
import { getActiveFieldUuid, getSelectedTrialPlacement } from 'current/selectors';
import {
  getExperimentApplication,
  getExperimentApplicationDate,
  getExperimentApplicationRate,
  getShowConfirmModal,
  getPrescriptionStatus,
  getError
} from 'experiment/selectors';
import { submitPrescription } from 'experiment/loaders';
import { calculateApplicationArea } from 'util/applicationArea';
import { getFieldByUuid } from 'fields/selectors';
import { getTrialPlacementOptions } from 'trial-placements/selectors';

// components
import ProductApplicationRate from './ProductApplicationRate';

export default connect(
  state => {
    const showConfirmModal = getShowConfirmModal(state);
    const prescriptionStatus = getPrescriptionStatus(state);
    const selectedTrialPlacementId = getSelectedTrialPlacement(state);
    const error = getError(state);
    const fieldId = getActiveFieldUuid(state);
    const activeField = getFieldByUuid(state, fieldId);
    const fieldArea = activeField.area;
    const selectedTrialPlacement = getTrialPlacementOptions(state)[selectedTrialPlacementId];
    const championArea = selectedTrialPlacement.zones.champion.area;

    return {
      applicationArea: calculateApplicationArea(fieldArea, championArea),
      applicationRate: getExperimentApplicationRate(state),
      fieldId: getActiveFieldUuid(state),
      selectedDate: getExperimentApplicationDate(state),
      selectedTrialPlacementId,
      fungicide: getExperimentApplication(state),
      showConfirmModal,
      prescriptionStatus,
      error
    };
  }, dispatch => ({
    onChangeProductApplicationRate: (value) => {
      dispatch(updateProductApplicationRate(value));
    },
    onSetShowConfirmModal: (showModal) => {
      dispatch(setShowConfirmModal(showModal));
    },
    onConfirmDetails: async ({
      productId,
      fieldId,
      selectedTrialPlacementId,
      year,
      cropName,
      seasonName,
      applicationRate     
    }) => {
      dispatch(setPrescriptionStatus('pending'));
      try {
        await submitPrescription({
          productId,
          fieldId,
          selectedTrialPlacementId,
          year,
          cropName,
          seasonName,
          applicationRate 
        });
        dispatch(setPrescriptionStatus('resolved'));
        window.location = '/static/fv2/#/experiments';
      } catch (e) {
        dispatch(setPrescriptionStatus(undefined));
        dispatch(setError(e.message || e.statusText));
        dispatch(setShowConfirmModal(false));
      }
    }
  })
)(ProductApplicationRate);
